import React, { useCallback, useEffect, useRef, useState } from "react"
import { Card } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation, Link } from "react-router-dom"
import { CardBody } from "../../../../../../_metronic/_partials/controls/index.js"
import {
  formatterRowComponent,
  initialFilterTable
} from "../../../../../../component/atoms/Tabel/index.jsx"
import { EmptyCard, Search, TableSkeleton, TableView } from "../../../../../../component/index.jsx"
import { getUrlParsingPageFilter } from "../../../../../../config/EndpointCollection.js"
import { ILLUSTRATION_CONSTANTS } from "../../../../../../constants/ImageConstants.js"
import { getMasterBaseDroneTeamList } from "../../../../../../redux/actions/MasterDataAction.jsx"
import { stringFormatting } from "../../../../../helpers/TextHelper.js"
import { useUrlParam } from "../../../../../hooks/useUrlParams.jsx"
import { DetailSvgIcon } from "../../../../../../component/atoms/Icons/SVG/index.jsx"
import { RoutesConstants } from "../../../../../../constants/RoutesConstants.js"
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers/AssetsHelpers.js"

export const MasterBaseTabDrone = ({ id }) => {
  const dispatch = useDispatch()
  const { General, MasterData } = useSelector((state) => state)
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const [isActiveSearch, setIsActiveSearch] = useState(false)
  const [search, setSearch] = useState({ keyword: "" })
  const formRef = useRef()
  const [queryStringObj, setQueryStringObj] = useState(undefined)
  const urlParams = useUrlParam()
  const [currentParam] = useState({
    ...initialFilterTable
  })

  useEffect(() => {
    if (queryStringObj?.keyword) {
      setSearch({ keyword: queryStringObj?.keyword })
      setIsActiveSearch(true)
    }
  }, [queryStringObj])

  useEffect(() => {
    setQueryStringObj(urlParams.getUrlParamsObj)
  }, [urlParams.getUrlParamsObj])

  function onSearch(value) {
    setSearch({ keyword: value.keyword })
    setIsActiveSearch(true)
    let param = {
      ...currentParam,
      keyword: value.keyword
    }
    const url = getUrlParsingPageFilter(param)
    history.push({ pathname: location.pathname, search: url })
  }

  function resetSearch() {
    let param = {
      ...currentParam,
      keyword: ""
    }
    const urlParam = getUrlParsingPageFilter(param)
    setSearch({ keyword: "" })
    setIsActiveSearch(false)
    history.push({ pathname: location.pathname, search: urlParam })
  }

  const changePage = useCallback(
    (param) => {
      let urlParam
      if (param.sortField != null) {
        urlParam = getUrlParsingPageFilter({
          ...currentParam,
          ...param,
          sort: param?.sortField ? param.sortField + "," + param.sortOrder : "",
          keyword: search.keyword
        })
      } else {
        urlParam = getUrlParsingPageFilter({
          ...currentParam,
          ...param,
          keyword: search.keyword
        })
      }
      history.push({ pathname: location.pathname, search: urlParam })
    },
    [dispatch, search, currentParam]
  )

  const fetchQueryParamData = (param) => {
    return dispatch(getMasterBaseDroneTeamList(id, param))
  }

  useEffect(() => {
    if (id) {
      const result = location?.search
      if (!result || result === '') {
        const defaultParams = getUrlParsingPageFilter(currentParam)
        history.replace({ pathname: location.pathname, search: defaultParams })
      } else {
        fetchQueryParamData(result)
      }
    }
  }, [location.search, id])

  const columnProperties = [
    {
      text: t("label_team_name"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <>
            <div className={"font-weight-bolder font-size-lg"}>
              {stringFormatting(e.team_name)}
            </div>
          </>
        )
      }
    },
    {
      text: t("label_team_member"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <>
            <div className={"font-size-lg"}>
              {stringFormatting(e.team_member)}
            </div>
          </>
        )
      }
    },
    {
      text: t("label_description"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <>
            <div className={"font-size-lg"}>
              {stringFormatting(e.description) || "-"}
            </div>
          </>
        )
      }
    },
    {
      text: t("table_header_action"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <div className={'d-flex align-items-center'}>
            <Link to={RoutesConstants.FIELD_OFFICER.DETAIL_FO_AGRONOMIST_TEAM(e?.id)}>
              <div className="btn btn-icon btn-detail btn-hover-secondary btn-md">
                <DetailSvgIcon size="2x" />
              </div>
            </Link>
          </div>
        )
      }
    }
  ]

  return (
    <>
      <div className={"filter-container"}>
        <div className={"position-relative d-flex flex-wrap justify-content-between align-items-center mb-10"}>
          <Search
            isActiveSearch={isActiveSearch}
            placeholder={t("placeholder_search_team_name")}
            onSubmitForm={onSearch}
            initialValues={search}
            innerRef={formRef}
            name={"keyword"}
            trigerReset={resetSearch}
          />
        </div>
      </div>
      <Card>
        <CardBody>
          {General?.loading ? (
            <TableSkeleton column={4} row={10} />
          ) : (MasterData?.pageData ?? []).length === 0 ? (
            <EmptyCard
              subtitle={
                isActiveSearch ? t("messages_response_empty_search_subtitle") : ""
              }
              image={
                isActiveSearch
                  ? toAbsoluteUrl(ILLUSTRATION_CONSTANTS.EMPTY_STATE_NO_DATA)
                  : toAbsoluteUrl(ILLUSTRATION_CONSTANTS.EMPTY_STATE_DESKTOP)
              }
              body={
                isActiveSearch
                  ? t("messages_response_searching_not_found")
                  : t("messages_response_no_custom", { custom: t("label_team_drone") })
              }
            />
          ) : (
            ""
          )}
          <TableView
            dataTable={MasterData?.pageData ?? []}
            currentPage={MasterData?.page?.currentPage ?? 1}
            currentElement={MasterData?.page?.currentElement ?? 10}
            totalCount={MasterData?.page?.totalCount ?? 0}
            columnProperties={columnProperties}
            callbackAfterPageChange={changePage}
            loadingGetData={General?.loading}
            initialFilterTable={currentParam}
            ignoreSinglePage
            rowClasses={() => {
              return "cursor-pointer"
            }}
          />
        </CardBody>
      </Card>
    </>
  )
}

